import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Grid,
  Box,
  Switch,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Toolbar,
  CircularProgress,
  InputAdornment,
  makeStyles,
  TextField as Input
} from "@material-ui/core";

import Widget from '../../components/Widget/Widget'
import { Typography } from '../../components/Wrappers/Wrappers'

import useStyles from "./styles";
import "../../static/css/global.css";
import moment from 'moment'

//icons
import Profile from "../../static/images/default-profile.png";


//context
import {
  useUsersState,
  getUsersRequest,
  updateUserStatus,
  updateEnterPriseStatus,
} from "../../context/UsersContext";

// Icons
import {
  Search as SearchIcon
} from '@material-ui/icons'

import config from "../../config";

//Function to sort data
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

//Table headings
const headCells = [
  { numeric: true, disablePadding: false, label: '#', sort: false, width: '50px', align: 'center' },
  { id: "first_name", disablePadding: true, label: 'NAME', sort: true, align: "center" },
  { id: "email", disablePadding: false, label: "EMAIL", sort: true, align: "center" },
  { id: "role", numeric: true, disablePadding: false, label: "ACCOUNT", sort: true, align: "center" },
  { id: "role", numeric: true, disablePadding: false, label: "ENTERPRISE", sort: true, align: "center" },
  { id: "propertiesCount", disablePadding: false, label: "PROPERTIES", sort: true, align: "center" },
  { id: 'is_banned', disablePadding: false, label: 'ACTIVE', sort: false, },
  { id: "created_on", numeric: true, disablePadding: false, label: "REGISTERED DATE", sort: true, align: "center" },
  { id: "promo_code", numeric: true, disablePadding: false, label: "PROMO CODE USED", sort: false, align: "center" },
  { id: "expiry_date", numeric: true, disablePadding: false, label: "EXPIRY DATE", sort: false, align: "center" },
];

//It will create table heading
function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow >
        {headCells.map((headCell, index) => (
          <TableCell
            className='TablesRow'
            align={headCell.align}
            width={headCell.width}
            key={index}
            // align={headCell.align ? 'center' : headCell.numeric ? 'left' : 'right'}
            padding={headCell.disablePadding ? 'none' : 'none'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sort ?
              (<TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                <Typography
                  noWrap
                  weight={'medium'}
                  variant={'body2'}
                  style={{ textTransform: "uppercase" }}
                >
                  {headCell.label}
                </Typography>
              </TableSortLabel>
              ) :
              (<Typography
                noWrap
                weight={'medium'}
                variant={'body2'}
                style={{ textTransform: "uppercase" }}
              >
                {headCell.label}
              </Typography>)
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

//Users component
const Users = (props) => {
  const classes = useStyles();
  const context = useUsersState();

  var [users, setBackUsers] = useState(
    context.users.users
  );

  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('created_date')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [userRows, setUsersRows] = useState(context.users.users)
  const [searchVal, setSearchVal] = useState('');

  //React hook which calls when page loads
  useEffect(() => {
    getUsersRequest(context.setUsers);
  }, []); // eslint-disable-line


  //React hook which calls when context value change
  useEffect(() => {
    setBackUsers(context.users.users);
    setUsersRows(context.users.users);
  }, [context]);

  //Function to store Sort by and property to sort
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  //Function to call when pagination value change
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  //Function to set value of rows per page
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  //Function to search

  const handleSearch = e => {
    let value = e.currentTarget.value.replace(/^\s+/, "")
    setSearchVal(value)
    setPage(0)
    const newArr = userRows.data.filter(c => {
      var name = `${c.first_name} ${c.last_name}`;
      return name && (name.toLowerCase().includes(value.toLowerCase()) || c.email.toLowerCase().includes(value.toLowerCase()))
    })
    setBackUsers({ isLoaded: true, data: newArr })
  }


  // Function call to ban/unban user
  const handleChange = async (event, _id) => {
    await updateUserStatus(context.setUsers, {
      is_active: event.target.checked ? true : false,
      user_id: _id
    });
    await getUsersRequest(context.setUsers);
  };

  // Function call to ban/unban user
  const handleChangeToEntrepreneur = async (event, _id , role) => {
    await updateEnterPriseStatus(context.setUsers, {
        user_id: _id,
        is_applied: role == 7 ? 0 : 1,
    });
    await getUsersRequest(context.setUsers , true , _id , users.data );
  };


  //Function call to redirect to user details screen
  const redirectToDetails = async (user_id) => {
    props.history.push({
      pathname: process.env.PUBLIC_URL + '/app/users/details',
      state: { user_id: user_id }
    })
  }
console.log("context.users" , context.users )
console.log("conditions !users.data" , !users.data , "users.data", users.data)
console.log("conditions !context.users.isLoaded" , !context.users.isLoaded , "context.users.isLoaded" , context.users.isLoaded)
  return (
    <Grid container spacing={3}>
      {/* Search Panel */}
      <Grid item xs={12}>
        <Widget inheritHeight>
          <Grid container spacing={5}>
            <Grid item md={4} xs={4} sm={4}>
              <Box>
                <span className={classes.mainPageTitle}><b>User Management</b>
                </span>
              </Box>
            </Grid>
            <Grid item md={4} xs={4} sm={4}>
            </Grid>
            <Grid md={4} xs={4} sm={4} >
              <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'flex-end'}
                marginRight={'5px'}
                marginTop={'10px'}
              >
                <Input
                  fullWidth
                  id="search-field"
                  // label="Search"
                  margin="dense"
                  variant="outlined"
                  onChange={(e) => handleSearch(e)}
                  value={searchVal}
                  placeholder='Search By Name or Email'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {" "}  <SearchIcon /> {" "}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

            </Grid>
          </Grid>
        </Widget>
      </Grid>


      {!context.users.isLoaded || !users.data ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100vw"}
          height={"calc(100vh - 200px)"}
        >
          <CircularProgress size={50} />
        </Box>
      ) : (
        <div className='smallTableuser'>
          <Grid item xs={12}>
            <Paper className={classes.root}>
              <TableContainer className={classes.container}>
                <Table
                  className='thtdprsmall'
                  aria-labelledby="tableTitle"
                  aria-label="enhanced table">

                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={users.data.length}
                  />
                  {
                    users.data &&
                      users.data.length > 0 ?
                      <TableBody className="whitespace-nowrap">
                        {stableSort(users.data, getComparator(order, orderBy))
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            return (
                              <TableRow
                                hover
                                tabIndex={-1}
                                key={index}
                                style={{ cursor: 'pointer' }}
                              >
                                <TableCell
                                  // component="th"
                                  scope="row"
                                  // padding='10px'
                                  width={'10px'}
                                  className={classes.cell}
                                  onClick={() => redirectToDetails(row.id)}>
                                  <Typography variant={'body2'}>
                                    {(page * rowsPerPage) + index + 1}
                                  </Typography>
                                </TableCell>

                                <TableCell onClick={() => redirectToDetails(row.id)}>
                                  <Box style={{ display: "flex", alignItems: "center" }} >

                                    {row.image === null ? <img style={{ borderRadius: '50%', height: '50px' }} src={Profile} alt="" /> :
                                      <img src={row.image} className={classes.profilePictureUser} alt='profile' />}
                                    {/* {profile.data.image === null ? <img style={{ borderRadius: '50%', height: "200px" }} src={Profile} alt="" /> :
                                      <img src={profile.data.image} className={classes.profilePictureUserdetail} alt='profile' />} */}
                                    <Typography variant={'body2'} className={classes.Username}> {`${row.first_name} ${row.last_name} `}
                                    </Typography>

                                  </Box>
                                </TableCell>

                                <TableCell onClick={() => redirectToDetails(row.id)}><Typography variant={'body2'} style={{ textAlign: "left" }}>{row.email}</Typography></TableCell>
                                <TableCell onClick={() => redirectToDetails(row.id)}><Typography variant={'body2'} style={{ textAlign: "center" }}>
                                  {row.role == 1 ? "Basic"
                                    : row.role == 2 ? "Basic Plus"
                                    : row.role == 3 ? "Investor"
                                    : row.role == 4 ? "Investor Plus"
                                    : row.role == 5 ? "Partnership"
                                    : row.role == 6 ? "Partnership Plus"
                                    : row.role == 7 ? "Enterprise"
                                    : "--"}
                                </Typography></TableCell>
                                <TableCell >
                                  <Typography variant={'body2'} style={{ textAlign: "center" }}>
                                    <Switch
                                      checked={row.role == 7}
                                      onChange={(e) => handleChangeToEntrepreneur(e, row.id , row.role)}
                                      color="primary"
                                      name="checkedB"
                                      style={{cursor : "pointer"}}
                                      inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                  </Typography>
                                </TableCell>
                                <TableCell onClick={() => redirectToDetails(row.id)}>
                                  <Typography variant={'body2'} style={{ textAlign: "center" }}> {row.propertiesCount}
                                  </Typography>
                                </TableCell>
                                <TableCell onClick={() => redirectToDetails(row.id)}>
                                  <Typography variant={'body2'} style={{ textAlign: "center" }}>
                                    <Switch
                                      checked={row.is_active}
                                      onChange={(e) => handleChange(e, row.id)}
                                      color="primary"
                                      name="checkedB"
                                      inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                  </Typography>
                                </TableCell>
                                <TableCell onClick={() => redirectToDetails(row.id)}>
                                  <Typography variant={'body2'} style={{ textAlign: "center" }} >
                                    {moment(row.created_on).format("DD-MMM-YYYY")}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant={'body2'} style={{ textAlign: "center" }}>
                                    {row.referral_code ? row.referral_code : "--"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant={'body2'} style={{ textAlign: "center" }}>
                                    {row.referral_code_expired && row.referral_code_expired ? moment(row.referral_code_expired).format("DD-MMM-YYYY") : "--"}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                      :
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={headCells.length}>
                            <Typography
                              style={{ textAlign: 'center', padding: '10px 0px' }}
                              noWrap
                              variant={'h4'}>No Records</Typography>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                  }
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={config.defaultRowsPerPage}
                component="div"
                count={users.data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
        </div>
      )}
      <h1></h1>

    </Grid>
  )
}

export default withRouter(Users)
